import React from "react";
import { ButtonCommon } from "../CommonElement";
import logo from "../../assets/images/logo/logo279.png";
import { Form } from "antd";
import { FacebookFilled } from "@ant-design/icons";
const TheFooter = () => {
  const [form] = Form.useForm();
  const handleSubmit = (values) => {
    console.log("Email submitted:", values.email);
  };
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="the-footer the-footer-row">
        <div className="the-footer-column">
          <div className="logo">
            <img src={logo} alt="logo" />
          </div>
          <div className="address">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
              <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
            </svg>
            {"  "}
            187 Hùng Vương, Buôn Hồ, Đăklăk.
          </div>
          <div className="number">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
            </svg>
            {"  "}
            {"0945 477 279"}
          </div>
        </div>
        <div className="the-footer-column">
          <h4>Về chúng tôi</h4>
          <ul>
            <li>
              <a href="/">Trang chủ</a>
            </li>
            <li>
              <a href="/about">Sản phẩm</a>
            </li>
            <li>
              <a href="/services">Dịch vụ</a>
            </li>
            <li>
              <a href="/services">Liên hệ</a>
            </li>
          </ul>
        </div>
        <div className="the-footer-column">
          <h4>Chính sách</h4>
          <ul>
            <li>
              <a href="/">Bảo hành đổi trả</a>
            </li>
            <li>
              <a href="/about">Khuyến mãi</a>
            </li>
            <li>
              <a href="/services">Khách hàng thân thiết</a>
            </li>
            <li>
              <a href="/services">Đánh giá - Khiếu nại</a>
            </li>
          </ul>
        </div>
        <div className="the-footer-column">
          <h4>Follow Us</h4>
          <div className="_follow" x>
            <a href="https://www.facebook.com/auto279vn">
              <FacebookFilled />
            </a>
          </div>
          {/* <div className="form-address-group">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              style={{ gap: "16px" }}
            >
              <Form.Item
                name="email"
                label="Địa chỉ email"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập email!!!",
                  },
                  {
                    type: "email",
                    message: "Email sai định dạng hoặc email không đúng!!!",
                  },
                ]}
              >
                <input placeholder="Vui lòng nhập email..." />
              </Form.Item>
              <Form.Item>
                <ButtonCommon title={"ĐĂNG KÝ"} />
              </Form.Item>
            </Form>
          </div> */}
        </div>
      </div>
      <div className="the-footer copyright">
        Copyright by Auto279 {currentYear}
      </div>
    </>
  );
};

export default TheFooter;
